'use strict';
payableSetupController.$inject = [
	'$scope',
	'$rootScope',
	'$location',
	'$q',
	'dialogHelper',
	'apSetupService',
	'siteService',
	'invoiceService',
	'bankService',
	'vendorService',
	'accountService',
	'accountStructureService',
	'ACCOUNT_TYPES',
	'purchasingCategoryService',
	'$uibModal',
	'authService',
	'USER_CLAIMS',
	'ACH_SETUP',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('payableSetupController', payableSetupController);

function payableSetupController(
	$scope,
	$rootScope,
	$location,
	$q,
	dialogHelper,
	apSetupService,
	siteService,
	invoiceService,
	bankService,
	vendorService,
	accountService,
	accountStructureService,
	ACCOUNT_TYPES,
	purchasingCategoryService,
	$uibModal,
	authService,
	USER_CLAIMS,
	ACH_SETUP,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.busyPromise = $q
		.all([
			$scope.vm.loadBanks($scope.vm),
			$scope.vm.loadSites($scope.vm),
			$scope.vm.loadVendors($scope.vm),
			$scope.vm.loadAccountStructures($scope.vm),
			$scope.vm.loadCategories($scope.vm),
			$scope.vm.getUnPaidACHCount($scope.vm),
		])
		.then(function () {
			$scope.vm.loadAPSetup($scope.vm);
		});

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			tab: authService.authentication.achSetupId === ACH_SETUP.GlobalLevel ? 'ACH' : 'Category',
			categoryFilter: {
				search: '',
				propertyName: 'Code',
				reverse: false,
			},
			categoriesBarLimit: 15,
			categoriesStartIndex: 0,
			categories: [],
			apSetup: null,
			banks: [],
			sites: [],
			vendors: [],
			unPaidACHCount: null,
			accountTypeIds: ACCOUNT_TYPES,
			ACH_SETUP: ACH_SETUP,
			unifiedAccountMask: null,
			assetAccountMask: null,
			liabilityAccountMask: null,
			backupAPSetup: null,
			typeaheadLimit: 10,
			errors: null,
			validationErrors: [],
			vendorBarLimit: 10,
			vendorStartIndex: 0,
			busyMessage: BUSY_MESSAGE.Loading,
			achSetupId: authService.authentication.achSetupId,
			hideACH: authService.authentication.achSetupId !== ACH_SETUP.GlobalLevel,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'Setup', 'payable'),
		};

		function changeTab(model, tab) {
			model.tab = tab;
		}

		function sortby(model, propertyName) {
			model.categoryFilter.reverse = model.categoryFilter.propertyName === propertyName ? !model.categoryFilter.reverse : false;
			model.categoryFilter.propertyName = propertyName;
		}

		function formIsDirty() {
			return $scope.setupForm.$dirty;
		}

		function loadAPSetup(model) {
			return apSetupService.getAPSetup().then(_.partial(finishLoadingAPSetup, model));

			function finishLoadingAPSetup(model, response) {
				model.apSetup = response.data.apSetup;
				model.backupAPSetup = angular.copy(model.apSetup);
				return angular.noop;
			}
		}

		function save(model) {
			model.errors = null;
			model.validationErrors = [];
			if (model.isReadOnly) {
				return null;
			}

			$scope.setupForm.$setSubmitted();
			// validate that the credit and debit account masks are not all '?'
			var achMask = null;
			if (model.apSetup.DDCreditAccountNumber) {
				achMask = model.apSetup.DDCreditAccountNumber.replace(/\./g, '').replace(/\?/g, ''); // remove all '.' and '?'
				$scope.setupForm.creditAccount.$setValidity('validFormat', achMask.length !== 0);
			}
			if (model.apSetup.DDDebitAccountNumber) {
				achMask = model.apSetup.DDDebitAccountNumber.replace(/\./g, '').replace(/\?/g, ''); // remove all '.' and '?'
				$scope.setupForm.debitAccount.$setValidity('validFormat', achMask.length !== 0);
			}

			if (!$scope.setupForm.$valid) return false;

			model.busyMessage = BUSY_MESSAGE.Saving;
			$scope.busyPromise = apSetupService.saveAPSetup(model.apSetup).then(_.partial(finishSaving, model));

			function finishSaving(model, response) {
				if (response.data.isValid) {
					$scope.setupForm.$setPristine();
					return model.loadAPSetup();
				} else {
					model.errors = response.data.errors;
					model.validationErrors = response.data.validationErrors;
					return angular.noop;
				}
			}
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				model.sites = response.data.sites;
				return angular.noop;
			}
		}

		function loadBanks(model) {
			return bankService.getBanks().then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;
				return angular.noop;
			}
		}

		function loadVendors(model) {
			return vendorService.getVendors().then(_.partial(finishLoadingVendors, model));

			function finishLoadingVendors(model, response) {
				model.vendors = response.data.vendors;
				return angular.noop;
			}
		}

		function loadCategories(model) {
			return purchasingCategoryService.list().then(_.partial(finishLoadingCategories, model));

			function finishLoadingCategories(model, response) {
				model.categories = response.data;
				return angular.noop;
			}
		}

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingAccountStructures, model));

			function finishLoadingAccountStructures(model, response) {
				let accountStructures = response.data.accountStructure;
				model.unifiedAccountMask = accountStructures.UnifiedAccountMask;
				model.assetAccountMask = accountStructures.AssetAccountMask;
				model.liabilityAccountMask = accountStructures.LiabilityAccountMask;
				return angular.noop;
			}
		}

		function getUnPaidACHCount(model) {
			return invoiceService.getUnPaidACHCount().then(_.partial(finishGetACHCount, model));

			function finishGetACHCount(model, response) {
				if (response.data.isValid === true) {
					model.achCount = response.data.achCount;
				}
			}
		}

		function cancelSave(model) {
			$scope.setupForm.$setPristine();
			$scope.setupForm.$setUntouched();
			model.apSetup = angular.copy(model.backupAPSetup);
		}

		function searchAccountsbyAccountNumber(model, value, accountTypeId) {
			return accountService.searchAccount([accountTypeId], '', value, model.typeaheadLimit, true).then(_.partial(finishSearchAccounts, model));

			function finishSearchAccounts(model, response) {
				return response.data.accounts;
			}
		}

		function addOrEditCategory(model, categoryId) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/payable/purchasingCategory-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					size: 'topMoveUp',
					controller: [
						'$scope',
						'$uibModalInstance',
						'purchasingCategoryService',
						function ($scope, modalInstance, purchasingCategoryService) {
							$scope.codeUnique = true;
							$scope.UsedVendors = _.filter($scope.vm.vendors, function (item) {
								return !item.PurchasingCategoryId;
							});
							$scope.filteredVendorList = [];

							$scope.category = {
								Id: 0,
								Code: '',
								Description: '',
								Vendors: [],
							};

							if (categoryId) {
								model.busyCategoryMessage = BUSY_MESSAGE.Loading;
								$scope.busyCategoryPromise = purchasingCategoryService.get(categoryId).then(finishLoadingCategory);
							}

							function finishLoadingCategory(response) {
								$scope.category = response.data;
								$scope.UsedVendors = _.filter($scope.vm.vendors, function (item) {
									return !item.PurchasingCategoryId || item.PurchasingCategoryId === $scope.category.Id;
								});
								return angular.noop;
							}

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								checkCategoryCode: function () {
									var category = _.findWhere($scope.vm.categories, {
										Code: $scope.category.Code,
									});
									$scope.codeUnique = true;
									if (category && $scope.category.Id !== category.Id) {
										$scope.codeUnique = false;
									}
									return $scope.codeUnique;
								},
								isAllDisplayedVendorSelected: function () {
									return $scope.filteredVendorList.length === $scope.category.Vendors.length;
								},
								selectAllVendors: function () {
									if ($scope.isAllDisplayedVendorSelected()) {
										$scope.category.Vendors = [];
									} else {
										$scope.category.Vendors = angular.copy($scope.filteredVendorList);
									}
								},
								vendorSelected: function (vendorId) {
									var vendor = _.findWhere($scope.category.Vendors, {
										Id: vendorId,
									});
									return vendor ? true : false;
								},
								selectVendor: function (vendor) {
									var index = _.findIndex($scope.category.Vendors, function (item) {
										return item.Id === vendor.Id;
									});
									if (index > -1) {
										$scope.category.Vendors.splice(index, 1);
									} else {
										$scope.category.Vendors.push(vendor);
									}
								},
								save: function () {
									if (!$scope.addEditCategoryForm.$valid || !$scope.codeUnique) return false;

									model.busyCategoryMessage = BUSY_MESSAGE.Saving;
									if ($scope.category.Id === 0) {
										$scope.busyCategoryPromise = purchasingCategoryService.add($scope.category).then(finishAddingOrEditing);
									} else {
										$scope.busyCategoryPromise = purchasingCategoryService.update($scope.category).then(finishAddingOrEditing);
									}

									function finishAddingOrEditing(response) {
										$scope.errors = null;
										if (response.data.isValid) {
											modalInstance.close('reload');
										} else {
											$scope.errors = response.data.errors;
										}
									}
								},
								deleteCategory: function (categoryId) {
									$uibModal
										.open({
											template: require('@ajs/templates/fund/payable/purchasingCategory-delete-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												'purchasingCategoryService',
												function ($scope, modalInstance, purchasingCategoryService) {
													angular.extend($scope, {
														cancel: function () {
															modalInstance.close();
														},
														confirmDeleteCategory: function () {
															$scope.deletingPromise = purchasingCategoryService
																.deleteCategory(categoryId)
																.then(function (response) {
																	if (response.data.isValid) {
																		modalInstance.close(true);
																	} else {
																		$scope.errors = response.data.errors;
																	}
																});
														},
													});
												},
											],
										})
										.result.then(function (reload) {
											if (reload) {
												modalInstance.close('reload');
											}
										});
								},
							});
						},
					],
				})
				.result.then(function (reload) {
					if (reload) {
						model.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = $q.all([model.loadVendors(), model.loadCategories()]);
					}
				});
		}

		return angular.extend(model, {
			changeTab: _.partial(changeTab, model),
			sortby: _.partial(sortby, model),
			formIsDirty: formIsDirty,
			loadAPSetup: _.partial(loadAPSetup, model),
			save: _.partial(save, model),
			cancelSave: _.partial(cancelSave, model),
			loadSites: _.partial(loadSites, model),
			loadBanks: _.partial(loadBanks, model),
			loadVendors: _.partial(loadVendors, model),
			loadCategories: _.partial(loadCategories, model),
			loadAccountStructures: _.partial(loadAccountStructures, model),
			addOrEditCategory: _.partial(addOrEditCategory, model),
			searchAccountsbyAccountNumber: _.partial(searchAccountsbyAccountNumber, model),
			getUnPaidACHCount: _.partial(getUnPaidACHCount, model),
		});
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}
